import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="administration--join-requests--table"
export default class extends Controller {
  toggleDetails(event) {
    event.preventDefault();
    const row = event.currentTarget.closest("tr");
    const detailRow = row.nextElementSibling;
    if (detailRow) {
      detailRow.classList.toggle("hidden");
    }
  }
}
